let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("Wowvf"), load("8m00X")]).then(() => parcelRequire('5xRci'));